import { render, staticRenderFns } from "./OccupyingPositionBadge.vue?vue&type=template&id=ad0a8ff4&scoped=true"
import script from "./OccupyingPositionBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupyingPositionBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OccupyingPositionBadge.vue?vue&type=style&index=0&id=ad0a8ff4&prod&scoped=true&lang=css"
import style1 from "./OccupyingPositionBadge.vue?vue&type=style&index=1&id=ad0a8ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0a8ff4",
  null
  
)

export default component.exports